import { render, staticRenderFns } from "./commodity-order.vue?vue&type=template&id=025fc639&scoped=true&"
import script from "./commodity-order.vue?vue&type=script&lang=js&"
export * from "./commodity-order.vue?vue&type=script&lang=js&"
import style0 from "./commodity-order.vue?vue&type=style&index=0&id=025fc639&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025fc639",
  null
  
)

export default component.exports